import { render, staticRenderFns } from "./CompetitionOffState.vue?vue&type=template&id=cb97f220"
import script from "./CompetitionOffState.vue?vue&type=script&lang=js"
export * from "./CompetitionOffState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports